import React, { useEffect, useContext, useState } from 'react';
import { PureTranslator } from 'ggApp/modules/translator';
import { useMutation } from '@apollo/client';

import { OrderContext } from 'ggApp/shared/context/Order/OrderContext';

import CloseSmall from 'ggApp/shared/icons/CloseSmall';
import StraightFaceIcon from 'ggApp/shared/icons/StraightFace';
import { HappyFaceIcon } from 'ggApp/shared/icons/HappyFace';
import { StarFace } from 'ggApp/shared/icons/StarFace';
import { AngryFaceIcon } from 'ggApp/shared/icons/AngryFace';
import { SadFaceIcon } from 'ggApp/shared/icons/SadFaceIcon';

import { ORDER_MOOD, CAST_MOOD } from '../../../../../queries/getVotingTicket';
import { MoodEnum } from './types';
import { CloseButton, Container, Title, Text, List, MoodItem, ListCaption } from './styles';

const getMoodList = (mood: MoodEnum) => {
    switch (mood) {
        case MoodEnum.angry:
            return {
                icon: <AngryFaceIcon size={24} />,
                order: 1,
            };
        case MoodEnum.sad:
            return {
                icon: <SadFaceIcon size={24} color="#333" />,
                order: 2,
            };
        case MoodEnum.neutral:
            return {
                icon: <StraightFaceIcon size={24} color="#333" />,
                order: 3,
            };
        case MoodEnum.happy:
            return {
                icon: <HappyFaceIcon size={24} />,
                order: 4,
            };
        case MoodEnum.inLove:
        default:
            return {
                icon: <StarFace size={24} />,
                order: 5,
            };
    }
};

export const MoodSurvey = ({
    setVotingTicket,
    setSurveyError,
}: {
    setVotingTicket: (data: any) => void;
    setSurveyError: (val: boolean) => void;
}): JSX.Element => {
    const { orderNumber } = useContext(OrderContext);

    const [fetchVotingOptions, { data: votingData }] = useMutation(ORDER_MOOD, {
        onError: () => setSurveyError(true),
    });

    const [callCastVoteMutation] = useMutation(CAST_MOOD, {
        onCompleted: (data) => setVotingTicket(data?.castVote?.voteSlug),
    });

    useEffect(() => {
        fetchVotingOptions({
            variables: {
                entityId: orderNumber,
                slug: 'checkout-satisfaction',
            },
        });
    }, [orderNumber, fetchVotingOptions]);

    const [hide, setHide] = useState(false);

    return (
        <Container hide={hide}>
            <CloseButton onClick={() => setHide(true)} icon={<CloseSmall />} small />

            <Title>
                <PureTranslator tk="CHECKOUT_SURVEY_MOOD_TITLE" />
            </Title>
            <Text>
                <PureTranslator tk="CHECKOUT_SURVEY_MOOD_TEXT" />
            </Text>

            <List>
                {votingData?.getVotingTicket?.payload?.options?.map((i) => {
                    const { icon, order } = getMoodList(i.mood);

                    return (
                        <MoodItem
                            onClick={() =>
                                callCastVoteMutation({
                                    variables: {
                                        voteSlug: i.mood,
                                        ticket: votingData?.getVotingTicket?.ticket,
                                    },
                                })
                            }
                            key={i?.mood}
                            order={order}
                        >
                            {icon}
                        </MoodItem>
                    );
                })}
            </List>
            <ListCaption>
                <Text grayText>
                    <PureTranslator tk="CHECKOUT_SURVEY_HORRIBLE" />
                </Text>
                <Text grayText>
                    <PureTranslator tk="CHECKOUT_SURVEY_AWSOME" />
                </Text>
            </ListCaption>
        </Container>
    );
};
